<ng-template #psla let-membership="membership" let-brandWisePSLAData="brandWisePSLAData">
    <div class="psla-offer-container">
        @if (membership.active && brandWisePSLAData[membership.id]?.psla) {
            <div class="brand-psla-bg">
                <img src="/assets/images/lightning.svg" height="12" width="12" />
                <div class="brand-psla">{{ brandWisePSLAData[membership.id].psla }}</div>
            </div>
        }
        <img class="membership-icon" imageSrc="{{ assetsUrl }}/icon/web/brand/{{ membership.id }}" appDeferImageLoad />

        <div class="membership-card">
            <div class="membership-content">
                <span class="membership-name">{{ membership.label }}</span>
                <span class="membership-tagline">{{ membership.brand_tagline }}</span>
            </div>
            @if (membership.oft) {
                <div class="brand-offer-text">
                    <img src="{{ DEPLOY_URL }}/assets/images/offers_teal.svg" class="offer-icon" />
                    {{ membership.oft }}
                </div>
            }
        </div>
    </div>
</ng-template>

@if (memberships?.length > 1) {
    <div class="container">
        <app-gradient-heading [text]="'Restaurants'" [styles]="{ 'margin-left': '16px', 'margin-bottom': 0 }" />
        <div class="membership-items-wrapper">
            @for (membership of memberships; let i = $index; track membership.id) {
                <div
                    class="membership-image"
                    data-test="brands"
                    role="button"
                    tabindex="0"
                    [attr.aria-label]="membership.name"
                    (click)="isMobile ? showCategoryByBrand(membership, i + 1) : showMenuByBrand(membership, i + 1)">
                    <img
                        src="{{ DEPLOY_URL }}/assets/images/missing.png"
                        [imageSrc]="membership.image"
                        appDeferImageLoad
                        [alt]="membership.brand_tagline" />
                    <ng-container *ngTemplateOutlet="psla; context: { membership, brandWisePSLAData }"></ng-container>
                </div>
            }
        </div>
    </div>
}
